import React from 'react';
import PropTypes from 'prop-types';

// import config from '../../config';
// import LogoImageMobile from './sneakertime-logo-mobile.png';
// import LogoImage from './sneakertime-logo.png';

const Logo = props => {
  const { className, format, ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="139"
      height="42"
      fill="none"
      viewBox="0 0 139 42"
      className={className}
    >
      <path
        fill="#EE4D68"
        d="M76.81 23.914l-1.416 1.09c-.786-1.016-1.727-1.786-2.825-2.31-1.097-.524-2.3-.786-3.618-.786a7.997 7.997 0 00-3.987 1.032c-1.22.688-2.17 1.613-2.841 2.767-.672 1.163-1.007 2.465-1.007 3.914 0 2.186.753 4.011 2.26 5.477 1.506 1.465 3.405 2.194 5.698 2.194 2.521 0 4.625-.982 6.328-2.956l1.417 1.073a9.096 9.096 0 01-3.357 2.645c-1.343.622-2.841.933-4.495.933-3.152 0-5.633-1.048-7.45-3.136-1.523-1.768-2.284-3.897-2.284-6.394 0-2.628.925-4.839 2.767-6.632 1.85-1.793 4.159-2.693 6.943-2.693 1.678 0 3.2.335 4.552.99a8.918 8.918 0 013.315 2.792zM85.816 24.913c2.047 0 3.75.737 5.1 2.219 1.229 1.35 1.843 2.947 1.843 4.797 0 1.85-.647 3.472-1.94 4.864-1.294 1.383-2.964 2.08-4.995 2.08-2.046 0-3.708-.697-5.01-2.08-1.294-1.384-1.94-3.005-1.94-4.863 0-1.843.614-3.431 1.842-4.782 1.334-1.49 3.037-2.235 5.1-2.235zm-.008 1.67c-1.424 0-2.644.524-3.668 1.572-1.023 1.048-1.539 2.317-1.539 3.807 0 .958.238 1.85.696 2.686a5.025 5.025 0 001.891 1.924 5.14 5.14 0 002.612.68 5.2 5.2 0 002.612-.68 4.915 4.915 0 001.89-1.924 5.392 5.392 0 00.705-2.686c0-1.49-.516-2.759-1.54-3.807-1.023-1.048-2.242-1.572-3.659-1.572zM95.076 25.257h1.711v6.198c0 1.514.082 2.554.246 3.12.245.81.712 1.456 1.4 1.923.688.475 1.514.704 2.472.704s1.769-.229 2.432-.688a3.538 3.538 0 001.375-1.809c.172-.516.254-1.596.254-3.258v-6.198h1.752v6.517c0 1.826-.213 3.21-.647 4.135a4.886 4.886 0 01-1.932 2.177c-.859.524-1.94.786-3.234.786-1.293 0-2.382-.262-3.25-.786a4.926 4.926 0 01-1.948-2.194c-.426-.941-.64-2.35-.64-4.24v-6.387h.01zM109.248 25.257H111v1.94c.524-.761 1.073-1.334 1.654-1.71.581-.377 1.179-.566 1.809-.566.475 0 .983.148 1.515.45l-.893 1.442c-.36-.156-.663-.23-.908-.23-.573 0-1.122.238-1.654.705-.532.466-.933 1.195-1.212 2.177-.213.753-.319 2.284-.319 4.585v4.487h-1.752v-13.28h.008zM123.502 26.706l-1.097 1.138c-.917-.884-1.81-1.326-2.686-1.326-.556 0-1.031.18-1.432.548-.393.369-.598.794-.598 1.277 0 .434.164.844.491 1.229.328.4 1.015.867 2.063 1.4 1.277.654 2.145 1.293 2.596 1.899.45.614.671 1.31.671 2.088 0 1.089-.385 2.014-1.154 2.767-.77.753-1.728 1.138-2.882 1.138-.77 0-1.499-.164-2.203-.5a4.864 4.864 0 01-1.735-1.375l1.08-1.22c.876.983 1.802 1.474 2.784 1.474.688 0 1.269-.221 1.752-.655.483-.442.72-.958.72-1.547 0-.492-.163-.926-.474-1.302-.32-.377-1.04-.843-2.162-1.417-1.203-.614-2.022-1.228-2.456-1.834-.434-.597-.647-1.285-.647-2.063 0-1.007.344-1.842 1.032-2.513.688-.663 1.564-.999 2.62-.999 1.244 0 2.472.598 3.717 1.793zM137.117 34.124l1.441.753c-.475.925-1.024 1.679-1.638 2.243a6.572 6.572 0 01-2.095 1.302c-.778.295-1.654.442-2.637.442-2.169 0-3.872-.712-5.092-2.128-1.228-1.417-1.834-3.021-1.834-4.814 0-1.687.516-3.185 1.556-4.503 1.318-1.679 3.07-2.514 5.28-2.514 2.268 0 4.086.86 5.436 2.571.967 1.212 1.45 2.726 1.466 4.536h-11.978c.033 1.539.524 2.808 1.482 3.79.958.983 2.137 1.482 3.537 1.482.679 0 1.334-.114 1.981-.352A5.394 5.394 0 00135.66 36c.45-.385.933-1.007 1.457-1.875zm0-3.578c-.229-.909-.565-1.637-.999-2.186-.434-.548-1.015-.982-1.736-1.318a5.29 5.29 0 00-2.267-.5c-1.31 0-2.432.418-3.365 1.253-.688.614-1.204 1.523-1.556 2.743h9.923v.008z"
      ></path>
      <path
        fill="#23A0EC"
        d="M37.782 21.016l8.392 17.946h-1.94l-2.833-5.903h-7.753l-2.8 5.903h-2.006l8.507-17.946h.434zm-.229 3.807l-3.086 6.492h6.156l-3.07-6.492zM47.795 20.565h1.711v18.397h-1.71V20.565zM52.184 20.565h1.71v18.397h-1.71V20.565z"
      ></path>
      <path
        fill="#3DACED"
        d="M32.289 12.64l-17.39-8.055a2.712 2.712 0 00-3.602 1.318L.253 29.743a2.712 2.712 0 001.318 3.603l17.39 8.056c1.358.63 2.971.041 3.602-1.318l11.044-23.84a2.712 2.712 0 00-1.318-3.603z"
      ></path>
      <path
        fill="#B0E1F5"
        d="M12.562 6.283L2.225 28.6l19.94 9.236L32.5 15.519l-19.94-9.236z"
      ></path>
      <path
        fill="#EFCA80"
        d="M15.93 4.405L5.813 26.453l16.35 11.38 10.282-22.187L15.931 4.405z"
      ></path>
      <path
        fill="#EB94BD"
        d="M19.656 2.317L9.455 24.258l12.706 13.575 10.3-22.228L19.656 2.317z"
      ></path>
      <path
        fill="#EF6279"
        d="M23.504 0L13.172 22.269l8.99 15.564 10.299-22.22L23.504 0z"
      ></path>
      <path
        fill="#fff"
        d="M11.74 34.01a1.2 1.2 0 00-1.597.59 1.2 1.2 0 00.59 1.596 1.2 1.2 0 001.596-.59 1.215 1.215 0 00-.59-1.596z"
      ></path>
      <path
        fill="#3DACED"
        d="M11.624 34.247a.94.94 0 00-1.252.458.94.94 0 00.458 1.253.94.94 0 001.253-.459.937.937 0 00-.459-1.252z"
      ></path>
      <path
        fill="#fff"
        d="M11.55 34.41a.743.743 0 00-.982.36.743.743 0 00.36.983c.369.172.811.008.983-.36a.747.747 0 00-.36-.983z"
      ></path>
    </svg>
  )

  // if (format === 'desktop') {
  //   return <img className={className} src={LogoImage} alt={config.siteTitle} {...rest} />;
  // }

  // return <img className={className} src={LogoImageMobile} alt={config.siteTitle} {...rest} />;
};

const { oneOf, string } = PropTypes;

Logo.defaultProps = {
  className: null,
  // format: 'desktop',
};

Logo.propTypes = {
  className: string,
  // format: oneOf(['desktop', 'mobile']),
};

export default Logo;
